import { Flow } from 'signup-constants/Flow';
import { getIntegrationFlowSteps } from '../integrations-flow/getIntegrationFlowSteps';
import { Step } from '../views/Step';
import { getMicroappFlowSteps } from '../microapp-flow/getMicroappFlowSteps';
const SoftwareFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.Industry, Step.ManagementLevel, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.HubletSelection],
  postAccountCreation: [Step.CrmExperienceLevel],
  postExistingAccountSelection: []
};
const SoftwareFlowStepsWithConsiderationProfiles = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.ProductExperience, Step.ProblemAwareness, Step.Industry, Step.ManagementLevel, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.HubletSelection],
  postAccountCreation: [Step.CrmExperienceLevel],
  postExistingAccountSelection: []
};
export const GenericFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.ManagementLevel, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.HubletSelection],
  postAccountCreation: [Step.CrmExperienceLevel, Step.JobField],
  postExistingAccountSelection: []
};
const AcademyFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.JobField, Step.ManagementLevel, Step.CompanyName, Step.CompanySize, Step.CompanyDomain],
  postAccountCreation: [],
  postExistingAccountSelection: []
};
const DeveloperFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.JobRole, Step.CompanyName],
  postAccountCreation: [],
  postExistingAccountSelection: []
};
const HubSpotForStartupsFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain, Step.CompanySize, Step.OptionalPhoneNumber, Step.HubletSelection],
  postAccountCreation: [Step.CrmExperienceLevel],
  postExistingAccountSelection: [Step.CompanySize, Step.OptionalPhoneNumber]
};
const NoSurveyFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain, Step.HubletSelection],
  postAccountCreation: [],
  postExistingAccountSelection: []
};
const DirectoryListingFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.CompanyName, Step.CompanyDomain],
  postAccountCreation: [Step.CompanySize, Step.PhoneNumber],
  postExistingAccountSelection: [Step.CompanySize, Step.PhoneNumber]
};
const PartnerFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.ManagementLevel, Step.CompanyName, Step.CompanyDomain, Step.CompanySize, Step.OptionalPhoneNumber, Step.HubletSelection],
  postAccountCreation: [],
  postExistingAccountSelection: [Step.ManagementLevel, Step.CompanySize, Step.OptionalPhoneNumber]
};
const StandaloneCmsPartnerFlowSteps = {
  preVerification: [Step.UnauthedPartnerUserError],
  postVerification: [],
  postAccountCreation: [],
  postExistingAccountSelection: [Step.CmsPartnerCompanyDomainAndName, Step.HubletSelection]
};
const UserFlowsSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name],
  postAccountCreation: [],
  postExistingAccountSelection: []
};
const CmsFreeFlowSteps = {
  preVerification: [Step.LandingPage, Step.CodeVerification],
  postVerification: [Step.Password, Step.Name, Step.Industry, Step.ManagementLevel, Step.CompanyName, Step.CompanySize, Step.CompanyDomain, Step.CmsSignupIntent, Step.CmsBusinessMaturity, Step.HubletSelection],
  postAccountCreation: [],
  postExistingAccountSelection: []
};
export const FlowStepsMapping = {
  [Flow.Crm]: () => SoftwareFlowStepsWithConsiderationProfiles,
  [Flow.Marketing]: () => SoftwareFlowStepsWithConsiderationProfiles,
  [Flow.Sales]: () => SoftwareFlowStepsWithConsiderationProfiles,
  [Flow.Service]: () => SoftwareFlowStepsWithConsiderationProfiles,
  [Flow.Trial]: () => SoftwareFlowSteps,
  [Flow.CmsFree]: () => CmsFreeFlowSteps,
  [Flow.ClassroomTraining]: () => GenericFlowSteps,
  [Flow.AssetProvider]: () => GenericFlowSteps,
  [Flow.Purchase]: () => GenericFlowSteps,
  [Flow.Academy]: () => AcademyFlowSteps,
  [Flow.AcademyEmbedded]: () => AcademyFlowSteps,
  [Flow.Developers]: () => DeveloperFlowSteps,
  [Flow.CmsDevelopers]: () => DeveloperFlowSteps,
  [Flow.SolutionsProvider]: () => NoSurveyFlowSteps,
  [Flow.FbCrm]: () => NoSurveyFlowSteps,
  [Flow.DirectoryListing]: () => DirectoryListingFlowSteps,
  [Flow.HubspotForStartups]: () => HubSpotForStartupsFlowSteps,
  [Flow.HubSpotPartners]: () => PartnerFlowSteps,
  [Flow.Connect]: () => UserFlowsSteps,
  [Flow.StandaloneCmsPartner]: () => StandaloneCmsPartnerFlowSteps,
  [Flow.Integrations]: () => getIntegrationFlowSteps(),
  [Flow.ChatSpot]: () => UserFlowsSteps,
  [Flow.Microapp]: () => getMicroappFlowSteps()
};